import { MultiSelectCheckboxDropdown } from './dropdown/multi-select-checkbox-dropdown';
import { MultiSelectDropdown } from './dropdown/multi-select-dropdown';
import { Dropdown } from './dropdown/select-dropdown';
import { Menu } from './menu/select-menu';
export const Select = () => null;
Select.Menu = Menu;
Select.Dropdown = Dropdown;
Select.MultiSelectDropdown = MultiSelectDropdown;
Select.MultiSelectCheckboxDropdown = MultiSelectCheckboxDropdown;
//# sourceMappingURL=select.js.map